import {
  CLOSE_LOADER,
  SET_ERROR,
  SET_LOADER,
  SET_SUCCESS,
} from "../Types/AuthTypes";
import {
  SET_CASH_RECEIPT,
  SET_SPECIFIC_CASH_RECEIPT,
  RESET_SPECIFIC_SALES,
  SET_PENDING_SALES,
  SET_BALANCE,
} from "../Types/CashReceiptTypes";
import backendVerifiedUser from "../../api/backendVerifiedUser";

export const addCashReceipt = (data) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.post(
        "/add-cash-receipt",
        data
      );
      dispatch({ type: CLOSE_LOADER });

      dispatch({ type: SET_SUCCESS, payLoad: response.data.success.msg });

      return true;
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg,
      });
      return false;
    }
  };
};

export const getCashReceipt = () => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.get("/get-cash-receipt");
      dispatch({ type: CLOSE_LOADER });

      dispatch({ type: SET_CASH_RECEIPT, payLoad: response.data });

      return true;
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg,
      });
      return false;
    }
  };
};

export const getspecificCashReceipt = (id) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.get(
        `/get-specific-cash-receipt/${id}`
      );

      dispatch({ type: CLOSE_LOADER });

      dispatch({ type: SET_SPECIFIC_CASH_RECEIPT, payLoad: response.data });
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg,
      });
    }
  };
};

export const updateCashReceipt = (data, id) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.post(
        `/update-cash-receipt/${id}`,
        data
      );
      dispatch({ type: CLOSE_LOADER });

      dispatch({ type: SET_SUCCESS, payLoad: response.data.success.msg });
      dispatch({ type: RESET_SPECIFIC_SALES });
      return true;
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg,
      });
    }
  };
};

export const getCustomerBalance = (id) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.get(
        `/getCustomerBalance/${id}`
      );

      dispatch({ type: CLOSE_LOADER });

      dispatch({ type: SET_BALANCE, payLoad: response.data });
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg,
      });
    }
  };
};
// export const getSales = () => {
//   return async (dispatch) => {
//     dispatch({ type: SET_LOADER });
//     try {
//       const response = await backendVerifiedUser.get("/get-cash-receipt");

//       dispatch({ type: CLOSE_LOADER });

//       dispatch({ type: SET_SALES, payLoad: response.data });
//     } catch (err) {
//       dispatch({ type: CLOSE_LOADER });
//       console.log(err);
//       dispatch({
//         type: SET_ERROR,
//         payLoad: err.response?.data?.error?.msg,
//       });
//     }
//   };
// };

export const getPendingSalesById = (id) => {
  return async (dispatch) => {
    console.log("api hit to get pending sales by id")
    dispatch({ type: SET_LOADER });
    try {
      const response = await backendVerifiedUser.get(
        `/get-pending-sales-by-id/${id}`
      );
      console.log("******************************")
      console.log(response.data)
      console.log("******************************")
      dispatch({ type: CLOSE_LOADER });

      dispatch({ type: SET_PENDING_SALES, payLoad: response.data });
    } catch (err) {
      dispatch({ type: CLOSE_LOADER });
      console.log(err);
      dispatch({
        type: SET_ERROR,
        payLoad: err.response?.data?.error?.msg,
      });
    }
  };
};

